export enum CallState {
  Idle = 0,
  Calling = 2,
  Connected = 3,
  OnHold = 5,
  TryingAgent = 7,
}


/*
      States from Call Handling

      current (-1),      // remain in current state
      undefined (-1),
      sessionStart (0),       // initial session state
      componentStart (1),         // initial state when arriving to new component
      normalCreate (2),           // a normal create has been sent
      normalContinue (3),         // a normal continue has been sent
      ivrCreate (4),              // an ivr create has been sent
      //ivrContinue,            // an ivr continue has been sent (call is in queue)
      playingFile (5),            // ivr is playing message(s) (call is in queue)
      waitIvrTerm (6),            // wait for ivr to terminate call
      waitIvrTermTryAgent (7),    // wait for ivr to terminate call in order to try an idle agent
      waitIvrTermKickoutTime (8), // wait for ivr to terminate call in order to kick out call
      waitIvrTermKickoutNoAgents (9), // wait for ivr to terminate call in order to kick out call
      waitIvrTermQueuePause (10),  // wait for ivr to terminate call in order to take a queue pause
      activate (11),                // an activate has been sent
      waitIvrTermDTMF (12),  // wait for ivr to terminate call because of a dtmf event
      end (13);
 */
